import { Box, Grid } from '@material-ui/core'
import React from 'react'
import { useAuth0 } from '../../contexts/Auth0Context'
import { Header, Text, Button } from "@paro.io/base-ui";
import { IconDocumentText, IconUsers } from '@paro.io/base-icons';
import { steps } from '../../pages/byob-onboarding/ConnectQuickbooks';

const RegistrationLayout = ({ children, isByob }) => {
  const { loginWithRedirect } = useAuth0()

  const HeaderContent = () => (
    <div className="flex" >
      <Text size="sm" className="text-gray-400">
        Already have an account?
        <Button color="primary-on-dark" className="ml-2" onClick={() => loginWithRedirect()} label="Login" />
      </Text>
    </div>
  );

  return (
    <Box>
      {!isByob && <><div className="md:hidden">
        <Header reverseColor={true} size="sm" className="sm-padding-rm">
          <HeaderContent />
        </Header>
      </div>
        <div className="hidden md:block">
          <Header reverseColor={true} size="md">
            <HeaderContent />
          </Header>
        </div>
      </>}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'column', md: 'row', lg: 'row' }, // Explicitly setting more breakpoints
          width: '100%',
        }}
      >

        {isByob && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              bgcolor: '#060821',
              padding: 25,
              width: '100%',
              maxWidth: { xs: '100%', md: '33%' },
              minHeight: '100vh',
              color: '#fff',
              boxSizing: 'border-box',
            }}
          >
            <Header reverseColor={true} size="sm" className="sm-padding-rm" />
            <h1 style={{
              marginTop: '16px',
              marginBottom: '16px',
              color: '#fff',
              fontSize: '24px',
            }}>
              Get Started in 3 Simple Steps
            </h1>
            <Box style={{ position: 'relative', marginBottom: '16px' }}>
              {steps.map((step, index) => (
                <Box key={step.number} style={{ position: 'relative' }}>
                  <Grid container alignItems="center" style={{ marginBottom: '16px' }}>
                    <Box
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: `2px solid ${step.completed ? '#ffffff62' : '#248384'}`,
                        backgroundColor: step.completed ? '#248384' : 'transparent',
                        color: '#ffffff',
                        position: 'relative',
                        zIndex: 2,
                      }}
                    >
                      <span
                        style={{
                          fontSize: '20px',
                          fontWeight: 600,
                        }}
                      >
                        {step.number}
                      </span>
                    </Box>
                    <Box
                      style={{
                        fontSize: '16px',
                        fontWeight: 500,
                        marginLeft: 24,
                        color: '#ffffff',
                      }}
                    >
                      {step.title}
                    </Box>
                  </Grid>
                  {index < steps.length - 1 && (
                    <Box
                      style={{
                        position: 'absolute',
                        left: 23,
                        top: 48,
                        width: 2,
                        height: 16,
                        backgroundColor: '#ffffff',
                        zIndex: 1,
                      }}
                    />
                  )}
                </Box>
              ))}
            </Box>

            <p
              style={{
                color: 'gray',
                textAlign: 'left',
                marginBottom: '32px',
              }}
            >
              Join Paro's expert network. Get started with our AI-Powered Growth Platform and apply to our vetted marketplace. All experts begin here—complete your profile and apply for marketplace access once you're set up.
            </p>

            <p style={{ color: 'white', marginBottom: '8px' }}>
              You're about to transform how you run your firm
            </p>

            <p
              style={{
                color: 'gray',
                textAlign: 'left',
                marginBottom: '32px',
              }}
            >
              Create your account and securely import your clients to access AI-powered tools that handle your back office work so you can focus on growth.
            </p>

            <p
              style={{
                color: 'white',
                marginBottom: '8px',
              }}
            >
              Get access to:
            </p>
            <Box ml={4} mb={2}>
              <ul style={{ color: 'gray', listStyleType: 'disc' }}>
                <li><span className="text-white" >AI agents</span> that handle tasks automatically</li>
                <li><span className="text-white" >Custom AI workflows, checklists and templates</span> for any job</li>
                <li><span className="text-white" >Real-time insights</span> showing your most profitable opportunities</li>
                <li><span className="text-white" >Integrated contracts, billing and project management</span></li>
                <li><span className="text-white" >Apply to join our vetted marketplace</span> for access to Paro's client network <span><Button label="MarketPlace" size="sm" color="primary" onClick={() => { }} /></span></li>
              </ul>
            </Box>
            <p style={{ color: 'gray', marginTop: '20px' }}>
              <p style={{ color: 'white' }}>The result?</p> Grow your firm’s revenue without proportionally growing your overhead.
              <br />
              <br />
              Let's get you set up in under 5 minutes.
            </p>
            <Box sx={{ marginTop: 4 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                <IconDocumentText size="md" />
                <Box sx={{ marginLeft: 10 }}>
                  <p style={{ margin: 0 }}>
                    Import Your Book of Business
                  </p>
                  <p style={{ color: 'gray', margin: 0 }}>
                    Fast, secure, frictionless
                  </p>
                </Box>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 8 }}>
                <IconUsers size="md" />
                <Box sx={{ marginLeft: 10 }}>
                  <p style={{ margin: 0 }}>
                    Manage Clients
                  </p>
                  <p style={{ color: 'gray', margin: 0 }}>
                    Automated contracts, invoices & workflows
                  </p>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        <Box sx={{ flex: 1, padding: 50 }}>
          <Grid container spacing={2} style={{ paddingBottom: 6 }}>
            <Grid item xs={12}>
              {children}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

export default RegistrationLayout
